import Actions from '../../odata/actions';

const actions = new Actions('xeroChartOfAccount', 'xeroChartOfAccounts');

export default actions;
